/*
 * Copyright (c) 2024.  Rikesh Lal Shrestha
 * All Rights Reserved
 */
import Blowfish from 'es6-sladex-blowfish';

import {
  CLEAR_KEY,
  KEY_UPDATE, SINGLE_KEY_UPDATE
} from './types';
import { LOCALADMIN_DATA, LOCALADMIN_JWT, LOCALCLIENT_DATA, LOCALCLIENT_JWT, LOCALSTORAGE_ID, LOCALSYSTEM_DATA, LOCALSYSTEM_JWT, REACT_PACE_KEY } from "../../../constants/localConfig"
import { ADMIN_JWT_TOKEN, CLIENT_JWT_TOKEN, SYSTEM_JWT_TOKEN } from "../../../constants/appConfig"
import Toast from '../../../components/shared/Toast';


const getInitialStateFromLocalStorage = () => {

  let retuningObject = {}
  let mainLocalStorageData = localStorage.getItem(LOCALSTORAGE_ID);

  if (!mainLocalStorageData) {
    return retuningObject
  }

  let parsedMainLocalStorageData = JSON.parse(mainLocalStorageData);

  let encodedAdminData = parsedMainLocalStorageData[LOCALADMIN_DATA]
  let encodedClientData = parsedMainLocalStorageData[LOCALCLIENT_DATA]
  let encodedSystemData = parsedMainLocalStorageData[LOCALSYSTEM_DATA]
  let adminJWT = parsedMainLocalStorageData[LOCALADMIN_JWT]
  let clientJWT = parsedMainLocalStorageData[LOCALCLIENT_JWT]
  let systemJWT = parsedMainLocalStorageData[LOCALSYSTEM_JWT]
  try {
    if (encodedAdminData && encodedAdminData !== "{}") {
      // let parsedDecodedAdminData = JSON.parse(Blowfish.decrypt(encodedAdminData, REACT_PACE_KEY));
      let parsedDecodedAdminData = JSON.parse(encodedAdminData);

      if (adminJWT) {
        retuningObject = { ...retuningObject, ...parsedDecodedAdminData, [ADMIN_JWT_TOKEN]: adminJWT }
      }
    }

    if (encodedClientData && encodedClientData !== "{}") {
      // let parsedDecodedClientData = JSON.parse(Blowfish.decrypt(encodedClientData, REACT_PACE_KEY));
      let parsedDecodedClientData = JSON.parse(encodedClientData);

      if (clientJWT) {
        retuningObject = { ...retuningObject, ...parsedDecodedClientData, [CLIENT_JWT_TOKEN]: clientJWT }
      }
    }

    if (encodedSystemData && encodedSystemData !== "{}") {
      // let parsedDecodedSystemData = JSON.parse(Blowfish.decrypt(encodedSystemData, REACT_PACE_KEY));
      let parsedDecodedSystemData = JSON.parse(encodedSystemData);

      if (systemJWT) {
        retuningObject = { ...retuningObject, ...parsedDecodedSystemData, [SYSTEM_JWT_TOKEN]: systemJWT }
      }
    }

    return retuningObject
  } catch (err) {
    localStorage.clear();
    Toast(
      'Due to suspicious activity in authentication, you have been logged out. Please login.',
      'WARNING'
    );
    return {}
  }
}

const INITIAL_STATE = {
  payload: getInitialStateFromLocalStorage()
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const keyReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case KEY_UPDATE:
      return Object.assign({}, state, {
        payload: { ...state.payload, ...action.data },
      });

    case SINGLE_KEY_UPDATE:
      return Object.assign({}, state, {
        payload: { ...state.payload, ...action.data },
      })

    case CLEAR_KEY:
      return Object.assign({}, state, {})

    default:
      return state;
  }
};

export default keyReducer;
